import { styled } from 'styled-components';

export const Container = styled.li`
  background: var(--black-300);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: var(--border-radius-default);
  border: 1px solid var(--border-color-default);
  color: var(--text-standard-secondary);

  svg path {
    color: var(--text-destructive);
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(100% - var(--space-300) * 2);
    height: calc(100% - var(--space-300) * 2);
    margin: var(--space-300);
    gap: var(--space-150);
    box-shadow: 0px 0px 8px 0px rgba(242, 62, 102, 0.24);
  }
`;

